import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

const badgeVariants = cva("ui-badge", {
  variants: {
    tone: {
      success: "ui-badge-success",
      warning: "ui-badge-warning",
      info: "ui-badge-info",
      accent: "ui-badge-accent",
      danger: "ui-badge-danger",
      strong: "ui-badge-strong",
      neutral: "ui-badge-neutral"
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(({ className, tone, ...props }, ref) => (
  <span className={cn(badgeVariants({ tone }), className)} ref={ref} {...props} />
));

Badge.displayName = "Badge";
